
import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import EditorialLayout from '@/components/editorial/EditorialLayout';
import { PreviewPanel } from '@/components/email/PreviewPanel';
import { EditPanel } from '@/components/email/EditPanel';
import { EmailContentManager } from '@/components/email/EmailContentManager';
import { useEmailTemplate } from '@/hooks/email/useEmailTemplate';

const EmailTemplatePage: React.FC = () => {
  const {
    emailConfig,
    activeTab,
    setActiveTab,
    handleChange,
    saveTemplate,
    introText,
    setIntroText,
    saveIntroText
  } = useEmailTemplate();

  return (
    <EditorialLayout>
      <div className="max-w-7xl mx-auto py-8 px-4">
        <div className="mb-8">
          <h1 className="text-3xl font-bold">E-post maler</h1>
          <p className="text-gray-600 mt-1">
            Administrer maler for automatiserte e-poster
          </p>
        </div>
        
        <Tabs value={activeTab} onValueChange={setActiveTab}>
          <TabsList className="mb-6">
            <TabsTrigger value="edit">Rediger</TabsTrigger>
            <TabsTrigger value="preview">Forhåndsvisning</TabsTrigger>
            <TabsTrigger value="content">E-post innhold</TabsTrigger>
          </TabsList>
          
          <TabsContent value="edit">
            <EditPanel 
              emailConfig={emailConfig} 
              introText={introText}
              handleChange={handleChange} 
              setActiveTab={setActiveTab} 
            />
          </TabsContent>
          
          <TabsContent value="preview">
            <PreviewPanel 
              emailConfig={emailConfig}
              introText={introText}
              onSaveTemplate={saveTemplate} 
            />
          </TabsContent>
          
          <TabsContent value="content">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              <EmailContentManager
                initialContent={introText}
                onSave={saveIntroText}
                title="Introduksjonstekst"
                description="Teksten som vises i begynnelsen av intervju-forespørselen"
              />
            </div>
          </TabsContent>
        </Tabs>
      </div>
    </EditorialLayout>
  );
};

export default EmailTemplatePage;
